import {
    AvailableForBooking,
    OfferedService,
    OfferedServiceGroup,
    Psychologist,
} from "utils/interfaces"
import { isServiceHasSlots } from "utils/bookingAvailable"

const NO_FREE_SLOTS_MESSAGE = "Нет свободного времени"
const LOCKED_BY_COMPANY_MESSAGE = "Запись по\u00a0корпоративной скидке недоступна"
export class ServicesGroup {
    id: number
    name: string
    public_name_for_clients: string
    family: boolean
    onlyFree: boolean
    priority: number
    services: OfferedService[]
    readonly availableForBooking: AvailableForBooking

    constructor(
        group: OfferedServiceGroup,
        availableForBooking: AvailableForBooking,
        onlyFree: boolean
    ) {
        this.id = group.id
        this.name = group.name
        this.public_name_for_clients = group.public_name_for_clients
        this.family = group.family
        this.priority = group.priority
        this.services = []
        this.availableForBooking = availableForBooking
        this.onlyFree = onlyFree
    }

    static from(psy: Psychologist, onlyFree = false): ServicesGroup[] {
        return ServicesGroup.fromOfferedServiceList(psy, psy.offered_services, onlyFree)
    }

    static fromOfferedServiceList(
        psy: Psychologist,
        offeredServices: OfferedService[],
        onlyFree = false
    ): ServicesGroup[] {
        const groups = new Map<number, ServicesGroup>()
        for (let i = 0; i < offeredServices.length; i++) {
            const service = offeredServices[i]
            const groupId = service.service_type_group.id
            let group: ServicesGroup | undefined
            if (groups.has(groupId)) {
                group = groups.get(groupId)
            } else {
                group = groups
                    .set(
                        groupId,
                        new ServicesGroup(
                            service.service_type_group,
                            psy.available_for_booking,
                            onlyFree
                        )
                    )
                    .get(groupId)
            }
            if (group) group.services = [...group.services, service]
        }
        return [...groups.values()].sort((a, b) => a.priority - b.priority)
    }

    static findServiceGroup(groups: ServicesGroup[], serviceTypeId: number) {
        return groups.find((group) =>
            group.services.some((service) => service.service_type_id === serviceTypeId)
        )
    }

    static findService(groups: ServicesGroup[], serviceTypeId: number) {
        const group = ServicesGroup.findServiceGroup(groups, serviceTypeId)
        if (!group) return undefined
        return group.services.find((service) => service.service_type_id === serviceTypeId)
    }

    get availableStatusWithCompany(): { ok: boolean; reason?: string } {
        const applyLockByCompany = (service: OfferedService) => {
            return !service.available
        }

        if (this.services.every(applyLockByCompany)) {
            return { ok: false, reason: LOCKED_BY_COMPANY_MESSAGE }
        }
        return { ok: true }
    }

    get availableStatusWithSlots(): { ok: boolean; reason?: string } {
        const applyNoSlots = (service: OfferedService) => {
            return !isServiceHasSlots(service, this.availableForBooking, this.onlyFree)
        }

        if (this.services.every(applyNoSlots)) {
            return { ok: false, reason: NO_FREE_SLOTS_MESSAGE }
        }

        return {
            ok: true,
        }
    }

    get availableStatus(): { ok: boolean; reason?: string } {
        if (!this.availableStatusWithCompany.ok) {
            return { ok: false, reason: LOCKED_BY_COMPANY_MESSAGE }
        }

        if (!this.availableStatusWithSlots.ok) {
            return { ok: false, reason: NO_FREE_SLOTS_MESSAGE }
        }

        return {
            ok: true,
        }
    }
}
